import { AtlasWhoAmIResponse } from '@lib/api/whoami/types';
import { useSWRFetch } from '@hooks/useSWRFetch';
import { Response } from '@hooks/useSWRFetch/types';
import { ONE_HOUR_IN_MS } from '@helpers/constants';

export const useCurrentUserInfo = (): Response<AtlasWhoAmIResponse> => {
  const requestObject = {
    url: `catalog/api/whoami`,
    baseUrl: '',
  };

  return useSWRFetch<AtlasWhoAmIResponse>(requestObject, {
    revalidateOnFocus: false,
    dedupingInterval: ONE_HOUR_IN_MS,
  });
};
